/**
 * Mock notification service for development mode
 */

import type { NotificationConfig } from '../../types/notification';

/**
 * In-memory mock notification state for dev mode
 */
let mockNotification: NotificationConfig = {
  enabled: true,
  message: '🎮 Welcome to 8-Bit Composer! New features coming soon.',
  updatedAt: new Date().toISOString(),
};

/**
 * Mock GET /admin/notification
 */
export const mockGetNotification = async (): Promise<NotificationConfig> => {
  return { ...mockNotification };
};

/**
 * Mock PUT /admin/notification
 */
export const mockUpdateNotification = async (
  enabled: boolean,
  message: string
): Promise<NotificationConfig> => {
  mockNotification = {
    enabled,
    message,
    updatedAt: new Date().toISOString(),
  };
  return { ...mockNotification };
};
